import {useEffect, useCallback, useRef} from 'react';
import {compatibilityTips} from '@/domains/document/DocHome/common/compatibilityTips';
import {getIsBrowserCompatiable} from '@/rte/editor';

const useCompatibilityTips = () => {
    const closeTipsRef: any = useRef(null);

    const close = useCallback(() => {
        closeTipsRef.current && closeTipsRef.current();
    }, []);

    useEffect(() => {
        return close;
    }, [close]);

    const show = useCallback((editor: any) => {
        close();
        if (getIsBrowserCompatiable(editor)) {
            closeTipsRef.current = compatibilityTips();
        }
    }, [close]);

    return [show];
};

export default useCompatibilityTips;
